// extracted by mini-css-extract-plugin
export default {"group":"VesselGroupValue_group__1Lbw3","group_label":"VesselGroupValue_group_label__TmGWh","color_block":"VesselGroupValue_color_block__hP-NB"};